import React, {Component} from "react";
import {Button, Col, Drawer, Form, Icon, Row, Select} from 'antd';

const {Option} = Select;

class FilterDrawer extends Component {
  constructor(props) {
    super(props);
    this.btnRef = React.createRef();

    this.state = {
      filterVisible: false,
      clientFilterType: '',
      locationFilterType: '',
      assetTypeFilterType: '',
      assetMakeFilterType: '',
      assetSubTypeFilterType: '',
      assetModelFilterType: '',
      assetOwnerFilterType: '',
      formPayload: {},
    }
  }

  componentDidMount() {
    this.props.fetchAllFiltersData();
  }

  componentWillReceiveProps(nextProps) {
    // console.log('==> ', nextProps);
  }

  toggleFilterDrawer = () => {
    // console.log(this.state.formPayload);
    this.props.form.setFieldsValue({
      location: this.state.formPayload.location || [],
      client: this.state.formPayload.client || [],
      assetType: this.state.formPayload.assetType || [],
      assetSubType: this.state.formPayload.assetSubType || [],
      assetMake: this.state.formPayload.assetMake || [],
      assetModel: this.state.formPayload.assetModel || [],
      assetOwner: this.state.formPayload.assetOwner || [],
    });
    this.setState({
      filterVisible: !this.state.filterVisible,
    });
  };

  clearFilter = () => {
    this.props.form.setFieldsValue({
      location: [],
      client: [],
      assetType: [],
      assetSubType: [],
      assetMake: [],
      assetModel: [],
      assetOwner: [],
    });
  }

  handleSubmit = (e) => {
    const {match} = this.props;
    e.preventDefault();
    e.stopPropagation();

    this.props.form.validateFields((err, values) => {
      if(err) {
        return console.log(err);
      }
      let payload = {...values};
      if(payload.assetType && payload.assetType.length && (!payload.assetSubType || !payload.assetSubType.length || payload.assetSubType === '' || payload.assetSubType[0] === 'All')) {
        payload.assetSubType = this.props.equipmentSubTypes.map(item => item._id)
      }
      if(payload.assetMake && payload.assetMake.length && (!payload.assetModel || !payload.assetModel.length || payload.assetModel === '' || payload.assetModel[0] === 'All')) {
        payload.assetModel = this.props.assetModels.map(item => item._id)
      }
      // console.log(this.state);
      // console.log(this.props.assetModels);
      // console.log(values);
      this.setState({
        formPayload: payload,
        filterVisible: !this.state.filterVisible,
      });
      this.props.setSearchPayload(payload);

      // const btn = this.btnRef.current;
      // btn.style['color'] = 'tomato';
    });
  }

  handleSelect = (type, value) => {
    switch (type) {
      case 'client':
        this.setState({
          clientFilterType: value,
        });
        break;
      case 'location':
        this.setState({
          locationFilterType: value,
        });
        break;
      case 'assetType':
        this.setState({
          assetTypeFilterType: value
        });
        break;
      case 'assetMake':
        this.setState({
          assetMakeFilterType: value
        });
        break;
      case 'assetSubType':
        this.setState({
          assetSubTypeFilterType: value
        });
        break;
      case 'assetModel':
        this.setState({
          assetModelFilterType: value
        });
        break;
      case 'assetOwner':
        this.setState({
          assetOwnerFilterType: value,
        });
        break;
      default:

    }
  };

  handleAssetTypesChange = (e) => {
    const {form} = this.props;
    form.setFieldsValue({assetSubType: []});
    if(e.length === 1) {
      if(e[0] === 'All') {
        this.props.getEquipmentSubTypeByAssetTypes('All');
        this.setState({assetType: e});
      } else {
        this.props.getEquipmentSubTypeByAssetTypes(e);
        this.setState({assetType: e});
      }
    } else {
      this.props.getEquipmentSubTypeByAssetTypes(e);
      this.setState({assetType: e});
    }
  };

  handleAssetMakesChange = (e) => {
    const {form} = this.props;
    form.setFieldsValue({assetModel: []});
    if(e.length === 1) {
      if(e[0] === 'All') {
        this.props.getModelByAssetMakes('All');
        this.setState({assetType: e});
      } else {
        this.props.getModelByAssetMakes(e);
        this.setState({assetType: e});
      }
    } else {
      this.props.getModelByAssetMakes(e);
      this.setState({assetType: e});
    }
  };

  render() {
    const {getFieldDecorator} = this.props.form;
    const {
      clientFilterType, locationFilterType, assetTypeFilterType, assetMakeFilterType,
      assetSubTypeFilterType, assetModelFilterType, assetOwnerFilterType
    } = this.state;

    const {documentFilters} = this.props;

    const assetTypes = documentFilters && documentFilters.assetType;
    const assetMakes = documentFilters && documentFilters.assetMake;
    const assetOwners = documentFilters && documentFilters.assetOwner;

    const locationType = this.props.form.getFieldValue('location');
    const clientType = this.props.form.getFieldValue('client');
    const assetType = this.props.form.getFieldValue('assetType');
    const assetMake = this.props.form.getFieldValue('assetMake');
    const assetSubType = this.props.form.getFieldValue('assetSubType');
    const assetModel = this.props.form.getFieldValue('assetModel');
    const assetOwner = this.props.form.getFieldValue('assetOwner');

    let btnType = 'default';
    const payload = this.state.formPayload;
    if(JSON.stringify(payload) !== '{}') {
      if(payload.location && payload.location !== '' && payload.location.length)
        btnType = 'primary';
      else if(payload.location && payload.location !== '' && payload.location.length)
        btnType = 'primary';
      else if(payload.location && payload.location !== '' && payload.location.length)
        btnType = 'primary';
      else if(payload.client && payload.client !== '' && payload.client.length)
        btnType = 'primary';
      else if(payload.assetType && payload.assetType !== '' && payload.assetType.length)
        btnType = 'primary';
      else if(payload.assetSubType && payload.assetSubType !== '' && payload.assetSubType.length)
        btnType = 'primary';
      else if(payload.assetMake && payload.assetMake !== '' && payload.assetMake.length)
        btnType = 'primary';
      else if(payload.assetModel && payload.assetModel !== '' && payload.assetModel.length)
        btnType = 'primary';
      else if(payload.assetOwner && payload.assetOwner !== '' && payload.assetOwner.length)
        btnType = 'primary';
    }
    return (
      <div>
        <Button ref={this.btnRef} type={btnType}
                shape="round"
                onClick={this.toggleFilterDrawer}
                style={{position: 'fixed', right: '5px', top: '120px', zIndex: '1000'}}
                title={`Filter for Dashboard results`}>
          <Icon type="plus"/> Filter
        </Button>
        <Drawer
          title="Dashboard Filter"
          // width={500}
          onClose={this.toggleFilterDrawer}
          visible={this.state.filterVisible}
          bodyStyle={{paddingBottom: 80}}
          style={{width: `256px!important`}}
          maskClosable={false}
        >
          <Form layout="vertical" onSubmit={this.handleSubmit} hideRequiredMark>
            <Row gutter={8}>
              <Col>
                <Form.Item label="Location" style={{width: '90%'}}>
                  {getFieldDecorator('location')(
                    <Select
                      showSearch
                      mode="multiple"
                      filterOption={(input, option) =>
                        (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                      }
                      onSelect={(val) => this.handleSelect('location', val)}
                      placeholder="Please select location">
                      <Select.Option key={'AllLocation'}
                                     disabled={locationFilterType !== 'All' && locationType && locationType.length > 0}
                        // onClick={this.handleSelect.bind(this, 'location', 'All')}
                                     value={'All'}>All</Select.Option>
                      {(this.props.authUser && this.props.authUser.locations || []).map(item =>
                        <Select.Option key={item._id}
                          // onClick={this.handleSelect.bind(this, 'location', '')}
                                       disabled={locationType && locationType.findIndex(item => item === 'All') >= 0}
                                       value={item._id}>{item.name}</Select.Option>)}
                    </Select>,
                  )}
                </Form.Item>
              </Col>
              <Col>
                <Form.Item key={'client'} label={'Select Sub Location'} style={{width: '90%'}}>
                  {getFieldDecorator(`client`)(<Select
                    showSearch
                    mode="multiple"
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    placeholder={`Please Select Sub Location`}
                    onSelect={(val) => this.handleSelect('client', val)}
                  >
                    <Select.Option key={'AllClient'}
                      // onClick={this.handleSelect.bind(this, 'client', 'All')}
                                   disabled={clientFilterType !== 'All' && clientType && clientType.length > 0}
                                   value={'All'}>All</Select.Option>
                    {(this.props.authUser && this.props.authUser.clients || []).map(item =>
                      <Select.Option key={item._id}
                        // onClick={this.handleSelect.bind(this, 'client', item._id)}
                                     disabled={clientType && clientType.findIndex(item => (item === 'All')) >= 0}
                                     value={item._id}>{item.name}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>
              </Col>
              <Col>
                <Form.Item key={'assetType'} label={'Select Asset Type'} style={{width: '90%'}}>
                  {getFieldDecorator(`assetType`)(<Select
                    showSearch
                    mode="multiple"
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    onChange={this.handleAssetTypesChange}
                    placeholder={`Please Select Asset Type`}
                  >
                    <Select.Option key={'allAssetType'}
                                   onClick={this.handleSelect.bind(this, 'assetType', 'All')}
                                   disabled={assetTypeFilterType !== 'All' && assetType && assetType.length > 0}
                                   value={'All'}>All</Select.Option>
                    {(assetTypes || []).map(item =>
                      <Select.Option key={item._id}
                                     onClick={this.handleSelect.bind(this, 'assetType', '')}
                                     disabled={assetType && assetType.findIndex(item => (item === 'All')) >= 0}
                                     value={item._id}>{item.name}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>
              </Col>
              <Col>
                <Form.Item key={'assetSubType'} label={'Select Asset Sub Type'} style={{width: '90%'}}>
                  {getFieldDecorator(`assetSubType`)(<Select
                    showSearch
                    disabled={!(this.props.equipmentSubTypes && this.props.equipmentSubTypes.length)}
                    mode="multiple"
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    placeholder={`Please Select Asset Sub Type`}
                  >
                    <Select.Option key={'allAssetSubType'}
                                   onClick={this.handleSelect.bind(this, 'assetSubType', 'All')}
                                   disabled={assetSubTypeFilterType !== 'All' && assetSubType && assetSubType.length > 0}
                                   value={'All'}>All</Select.Option>
                    {(this.props.equipmentSubTypes || []).map(item =>
                      <Select.Option key={item._id}
                                     onClick={this.handleSelect.bind(this, 'assetSubType', '')}
                                     disabled={assetSubType && assetSubType.findIndex(item => (item === 'All')) >= 0}
                                     value={item._id}>{item.name}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>
              </Col>
              <Col>
                <Form.Item key={'assetMake'} label={'Select Asset Make'} style={{width: '90%'}}>
                  {getFieldDecorator(`assetMake`)(<Select
                    showSearch
                    mode="multiple"
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    onChange={this.handleAssetMakesChange}
                    placeholder={`Please Select Asset Make`}
                  >
                    <Select.Option key={'allAssetMake'}
                                   onClick={this.handleSelect.bind(this, 'assetMake', 'All')}
                                   disabled={assetMakeFilterType !== 'All' && assetMake && assetMake.length > 0}
                                   value={'All'}>All</Select.Option>
                    {(assetMakes || []).map(item =>
                      <Select.Option key={item._id}
                                     onClick={this.handleSelect.bind(this, 'assetMake', '')}
                                     disabled={assetMake && assetMake.findIndex(item => (item === 'All')) >= 0}
                                     value={item._id}>{item.name}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>
              </Col>
              <Col>
                <Form.Item key={'assetModel'} label={'Select Asset Model'} style={{width: '90%'}}>
                  {getFieldDecorator(`assetModel`)(<Select
                    showSearch
                    disabled={!(this.props.assetModels && this.props.assetModels.length)}
                    mode="multiple"
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    placeholder={`Please Select Asset Model`}
                  >
                    <Select.Option key={'allAssetModel'}
                                   onClick={this.handleSelect.bind(this, 'assetModel', 'All')}
                                   disabled={assetModelFilterType !== 'All' && assetModel && assetModel.length > 0}
                                   value={'All'}>All</Select.Option>
                    {(this.props.assetModels || []).map(item =>
                      <Select.Option key={item._id}
                                     onClick={this.handleSelect.bind(this, 'assetModel', '')}
                                     disabled={assetModel && assetModel.findIndex(item => (item === 'All')) >= 0}
                                     value={item._id}>{item.name}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>
              </Col>
              <Col>
                <Form.Item key={'assetOwner'} label={'Select Asset Owner'} style={{width: '90%'}}>
                  {getFieldDecorator(`assetOwner`)(<Select
                    showSearch
                    mode="multiple"
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    // onChange={this.handleAssetMakesChange}
                    placeholder={`Please Select Asset Owner`}
                  >
                    <Select.Option key={'allAssetOwner'}
                                   onClick={this.handleSelect.bind(this, 'assetOwner', 'All')}
                                   disabled={assetOwnerFilterType !== 'All' && assetOwner && assetOwner.length > 0}
                                   value={'All'}>All</Select.Option>
                    {(assetOwners || []).map(item =>
                      <Select.Option key={item._id}
                                     onClick={this.handleSelect.bind(this, 'assetOwner', '')}
                                     disabled={assetOwner && assetOwner.findIndex(item => (item === 'All')) >= 0}
                                     value={item._id}>{item.name}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>
              </Col>
            </Row>

            <div
              style={{
                position: 'absolute',
                right: 0,
                bottom: 0,
                width: '100%',
                borderTop: '1px solid #e9e9e9',
                padding: '10px 16px',
                background: '#fff',
                textAlign: 'right',
              }}
            >
              <Button type={'danger'} onClick={this.clearFilter} style={{marginRight: 8}} htmlType="button"
                      icon={'filter'}>
                Clear All
              </Button>
              <Button type="primary" htmlType="submit" icon={'filter'}>
                Apply Filter
              </Button>
            </div>
          </Form>
        </Drawer>
      </div>
    );
  }
}

const FilterForm = Form.create({
  name: 'global_state',
})(FilterDrawer);

export default FilterForm;
